<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15rem"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <main class="flex flex-col items-center justify-center">
      <fade-loader
        :loading="loading"
        :color="$primaryColor"
        :height="height"
        :width="width"
      ></fade-loader>
      <p class="mt-16 text-sm lg:text-xl font-semibold text-fg-default">
        Validating
      </p>
    </main>
  </el-dialog>
</template>
<script>
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'StartWireTransfer',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FadeLoader
  },
  data () {
    return {
      breakpoints,
      transferReason: '',
      loading: true,
      height: '20px',
      width: '5px'
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '20%' : breakpoints.mdAndUp ? '70%' : '65%'
    }
  },
  methods: {
    handleClose () {}
  }
}
</script>

<style scoped>
>>> .el-dialog__headerbtn {
  display: none !important;
}
li {
  word-break: normal;
}
.slide-fade-enter-active {
  animation: slide-fade 0.3s ease forwards;
}
.slide-fade-leave-active {
  animation: slide-fade 0.3s ease forwards alternate-reverse;
}

@media screen and (max-width: 768px) {
  >>> .el-radio__label {
    font-size: 12px;
  }
}
>>> .el-dialog {
  border-radius: 0.5rem !important;
}
>>> .el-radio__inner {
  height: 1.2rem;
  width: 1.2rem;
  border: 2px solid #bdbdbd;
}
@media screen and (min-width: 1280px) {
  >>> .el-dialog {
    margin-right: 33vw;
  }
}
@media screen and (min-width: 1680px) {
  >>> .el-dialog {
    margin-right: 34vw;
  }
}
</style>
